export default __webpack_public_path__ + "static/media/email.dbfb4aab.png";